import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCheck } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import Header from "../../components/payments/Header";
import Footer from "../../components/payments/Footer";
import {Loader} from "../../components/Loader";
import {Spin} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, RootState} from "../../store/types/store";
import {fetchPaymentStatusRequest} from "../../store/slices/payment-slice";
import {PaymentResponseRes} from "../../models/response/payment-status-response";

const PaymentsComplete = () => {
    const location = useLocation();
    const dispatch: AppDispatch = useDispatch();
    // State variables
    const [heading, setHeading] = useState("");
    const [body, setBody] = useState("");
    const [status, setStatus] = useState("");
    const [orderId, setOrderId] = useState("");
    const [appName, setAppName] = useState("");
    const [appReturnURL, setAppReturnURL] = useState("");
    const [paymentRef, setPaymentRef] = useState("");
    const [paymentResponse, setPaymentResponse] = useState<PaymentResponseRes>(null);
    const [paymentStatus, setPaymentStatus] = useState<string>("");

    const { loading, paymentStatusResponse, error } = useSelector(
        (state: RootState) => state.payment
    );

    useEffect(() => {
        setPaymentResponse(paymentStatusResponse || null);
        setPaymentStatus(paymentStatusResponse?.body.paymentRequest.status || "")
    }, [paymentStatusResponse]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const orderId = queryParams.get("orderId");
        const status = queryParams.get("status");
        const appName = queryParams.get("appName");
        const appReturnURL = queryParams.get("returnURL");
        const paymentRef = queryParams.get("paymentRef");

        setStatus(status || "");
        setOrderId(orderId || "");
        setAppName(appName || "");
        setAppReturnURL(appReturnURL || "");
        setPaymentRef(paymentRef || "");


        if (status === "success" && paymentStatus === "complete") {
            setHeading("Payment successful");
            setBody(
                "Your payment has been completed successfully. We sent an invoice to your email. Thank you for your purchase."
            );
        } else if (status === "cancelled") {
            setHeading("Payment cancelled");
            setBody("Your payment has been cancelled. Kindly contact us for any questions or concerns.");
        } else if (status === "failed") {
            setHeading("Payment failed");
            setBody("Your payment did not go through. Please check with your card provider or contact us for any questions or concerns.");
        }else {
            setHeading("Something went wrong");
            setBody("Hmmm, looks like you've followed an invalid payment request. Kindly contact us for any questions or concerns.");
        }
    }, [paymentRef, paymentStatus]);

    useEffect(() => {
        if(paymentRef) {
            dispatch(fetchPaymentStatusRequest(paymentRef));
        }
    }, [paymentRef]);

    return (
        <Spin spinning={loading || !paymentResponse} indicator={<Loader />}>
        <div className="container">
            <div className="container mt-5">
                <div className="row justify-content-center mb-3">
                    <div className="col-md-10">
                        <Header />
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <p className="text-heading">
                            <strong>
                                <FontAwesomeIcon
                                    size="2x"
                                    color={paymentStatus === "complete" ? "green" : "red"}
                                    icon={paymentStatus === "complete" ? faCheck : faXmark}
                                    style={{ verticalAlign: "middle", marginBottom: "5px", marginRight: "10px" }}
                                />
                                {heading}
                            </strong>
                        </p>

                        <p>{body}</p>

                        {paymentResponse?.body.paymentRequest.paymentData.orderId && <p>Order Reference: <b>{paymentResponse?.body.paymentRequest.paymentData.orderId}</b></p>}

                        {paymentResponse?.body.paymentRequest.paymentData.orderId &&

                            <a href={`${paymentResponse?.body.paymentRequest.appReturnURL}?paymentRef=${paymentRef}`}
                               type="button"
                               id="payhere-payment"
                               className="mt-5 btn btn-success btn-sm w-50 btn-custom-xs btn-app-return"
                            >
                                Return to {paymentResponse?.body.paymentRequest.appName}
                            </a>

                        }
                    </div>
                    <div className="col-md-4"></div>
                </div>
                <div className="row justify-content-center mt-5">
                    <div className="col-md-10">
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
        </Spin>
    );
};

export default PaymentsComplete;